<template>
  <div
    class="videoList-box"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        clearable
        @keyup.enter.native="getVideoList('status')"
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.vidId"
        placeholder="请输入帖子ID"
        clearable
        @keyup.enter.native="getVideoList('status')"
        size="small"
        class="param-input"
        style="width:220px"
      ></el-input> -->
      <el-select
        v-model="params.status"
        size="small"
        placeholder="是否上架"
        clearable
        @change="getVideoList('status')"
      >
        <el-option
          v-for="item in isActiveList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.moduleID"
        size="small"
        placeholder="选择父模块"
        clearable
      >
        <el-option
          v-for="item in sections"
          :value="item.id"
          :label="item.moduleName"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.sectionID"
        size="small"
        placeholder="选择子专题"
        clearable
        @change="getVideoList('status')"
      >
        <el-option
          v-for="item in subSections"
          :value="item.id"
          :label="item.sectionName"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getVideoList('status')"
        >搜索</el-button
      >
      <el-button type="success" size="small" @click="add()">新增</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="580"
    >
      <el-table-column
        prop="publisherID"
        label="上传者ID"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.video.publisher.uid }}</div>
        </template>
      </el-table-column>
      <el-table-column label="上传者头像" align="center" width="100">
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="imgUrl + scope.row.video.publisher.portrait"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="vidId" label="帖子ID" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.video.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reviewAccount"
        label="审核人"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.timer.reviewAccount || "-" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="vidType"
        label="帖子类型"
        align="center"
        width="90"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.vidType === "SP"
              ? "视频"
              : scope.row.vidType === "MOVIE"
              ? "影视"
              : scope.row.vidType === "COVER"
              ? "图文"
              : scope.row.vidType === "AD_SP"
              ? "视频广告"
              : scope.row.vidType === "HOOKUP"
              ? "约炮帖子"
              : "图片广告"
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="vidTitle"
        label="视频标题"
        align="center"
        :show-overflow-tooltip="true"
        width="250"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.video.title || "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="moduleName"
        label="模块"
        align="center"
        :show-overflow-tooltip="true"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.video.moduleName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sectionName"
        label="专题"
        align="center"
        :show-overflow-tooltip="true"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.video.sectionName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="coins"
        label="价格"
        align="center"
        :show-overflow-tooltip="true"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.timer.coins || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="100">
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="imgUrl + scope.row.video.cover"
          ></img-load>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="url" label="帖子预览" align="center" width="80">
        <template
          slot-scope="scope"
          v-if="
            scope.row.video.vidType === 'SP' ||
              scope.row.video.vidType === 'MOVIE'
          "
        >
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.video.sourceURL, 'video')"
          ></i>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span
            v-if="
              !scope.row.video.seriesCover ||
                !scope.row.video.seriesCover.length
            "
            >未知</span
          >
          <div
            v-else
            class="picturePreview"
            @click="
              previewPicture(scope.row.video.seriesCover, scope.row.video.id)
            "
          >
            <decrypt-img
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              :iPreviewSrcList="[]"
              fit="fill"
              v-for="(item, i) in scope.row.video.seriesCover"
              :key="i"
            ></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="标签"
        align="center"
        width="150"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ handlerTags(scope.row.video.tags || []) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reviewAt"
        label="自动上架时间"
        align="center"
        width="160"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.timer.reviewAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        width="160"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.video.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          >
          </el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeVideo(scope.row.video.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--新增-->
    <add-timeOnline ref="addTimeOnline" @closePop="closePop" @sections-getted="sections = $event"></add-timeOnline>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
    <!-- 分页组件 -->
    <div class="bottom">
      <div class="page">
        <el-pagination
          :page-sizes="[10, 25, 50, 100]"
          :current-page="params.pageNumber"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MediaPopup from "@/components/media-popup";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewPicture from "./components/previewPicture";
import AddTimeOnline from "./components/add-video";
import API from "@/api";
export default {
  components: {
    MediaPopup,
    PreviewPicture,
    AddTimeOnline,
  },
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      loading: false,
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 10,
        moduleID: "",
        sectionID: "",
        status: '',
      },
      isActiveList: [
        { label: "全部", value: '' },
        { label: "未上架", value: 1 },
        { label: "已上架", value: 2 },
      ],
      sections: []
    };
  },
  computed: {
    subSections() {
      const currentSection = this.sections.find(v => v.id === this.params.moduleID)
      if (currentSection) {
        return currentSection.allSection
      }
      return []
    }
  },
  watch: {
    'params.moduleID': {
      handler() {
        this.params.sectionID = '';
        this.getVideoList('status');
      }
    }
  },
  created() {
    this.getVideoList();
  },
  methods: {
    // 获取视频列表
    getVideoList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getVidTimeOnlineList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            // console.log(res)
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    handlerTags(tags) {
      var tag = "";
      if (tags && tags.length === 0) {
        return tag;
      }
      for (const t of tags) {
        tag === "" ? (tag += t.name) : (tag += "," + t.name);
      }
      return tag;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideoList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getVideoList();
    },
    // 图集预览
    previewPicture(pictureArr, id) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    handlerPreviewList() {
      this.getVideoList();
    },
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    // 新增
    add() {
      this.$refs.addTimeOnline.open();
    },
    edit(row) {
      this.$refs.addTimeOnline.open(row);
    },
    // 删除视频
    removeVideo(id) {
      this.$confirm("您确定要删除吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.delVidTimeOnline({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    closePop() {
      this.getVideoList();
    },
  },
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}
.videoList-box {
  min-height: 100vh;
  overflow-y: auto;
}
.bottom {
  margin-top: 20px;
  .btn {
    display: inline-block;
    margin-left: 20px;
  }
  .page {
    display: inline-block;
    float: right;
  }
}
.el-pagination {
  margin-top: 0 !important;
}
.dialog-footer {
  left: 0;
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
